// Environment-aware API configuration.
// - Localhost frontend -> localhost backend
// - Production frontend -> same-origin /api (unless overridden)

const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

const defaultApiBaseUrl = isLocalhost
	? 'http://localhost:8000/api'
	: isBrowser
		? `${window.location.origin}/api`
		: 'http://localhost:8000/api';

const rawApiBaseUrl = process.env.REACT_APP_API_URL || defaultApiBaseUrl;
const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, '');
const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api$/, '');

export const buildApiUrl = (path = '') => {
	const cleanPath = String(path).replace(/^\/+/, '');
	return cleanPath ? `${API_BASE_URL}/${cleanPath}` : API_BASE_URL;
};

export { BACKEND_BASE_URL };
export default API_BASE_URL;
